export const codeBasic = `<template>
<b-card-code title="Data Grid">
  <b-form-group>
    <label class="mb-0">Table Options</label>
    <div class="demo-inline-spacing">
      <b-form-checkbox v-model="striped"> Striped </b-form-checkbox>
      <b-form-checkbox v-model="bordered"> Bordered </b-form-checkbox>
      <b-form-checkbox v-model="borderless"> Borderless </b-form-checkbox>
      <b-form-checkbox v-model="outlined"> Outlined </b-form-checkbox>
      <b-form-checkbox v-model="small"> Small </b-form-checkbox>
      <b-form-checkbox v-model="hover"> Hover </b-form-checkbox>
      <b-form-checkbox v-model="dark"> Dark </b-form-checkbox>
      <b-form-checkbox v-model="resize"> Resize </b-form-checkbox>
      <b-form-checkbox v-model="reOrder"> Reordering </b-form-checkbox>
    </div>
  </b-form-group>

  <DxDataGrid
    id="gridContainer"
    :customize-columns="customizeColumns"
    :data-source="dataSource"
    key-expr="id"
    :show-borders="outlined"
    :remote-operations="true"
    :hover-state-enabled="hover"
    :show-column-lines="bordered"
    :show-row-lines="!borderless"
    :row-alternation-enabled="striped"
    :class="tempClass"
    :allow-column-resizing="resize"
    column-resizing-mode="widget"
    :allow-column-reordering="reOrder"
  >
    <DxScrolling row-rendering-mode="virtual" />
    <DxPaging :page-size="20" />
    <DxPager
      :visible="true"
      :allowed-page-sizes="pageSizes"
      :display-mode="displayMode"
      :show-page-size-selector="showPageSizeSelector"
      :show-info="showInfo"
      :show-navigation-buttons="showNavButtons"
    />
  </DxDataGrid>
  <div class="options">
    <div class="caption">Options</div>
    <div class="option-container">
      <div class="option">
        <DxSelectBox
          id="dispalyModes"
          :items="displayModes"
          display-expr="text"
          value-expr="value"
          v-model:value="displayMode"
        />
      </div>
      <div class="option">
        <DxCheckBox
          id="showPageSizes"
          text="Show Page Size Selector"
          v-model:value="showPageSizeSelector"
        />
      </div>
      <div class="option">
        <DxCheckBox
          id="showInfo"
          text="Show Info Text"
          v-model:value="showInfo"
        />
      </div>
      <div class="option">
        <DxCheckBox
          id="showNavButtons"
          text="Show Navigation Buttons"
          :disabled="isCompactMode"
          v-model:value="showNavButtons"
        />
      </div>
    </div>
  </div>

  <template #code>
    <!-- {{ codeBasic }} -->
  </template>
</b-card-code>
</template>

<script>
import { BFormGroup, BFormCheckbox } from 'bootstrap-vue';

import {
DxDataGrid,
DxScrolling,
DxPager,
DxPaging,
} from 'devextreme-vue/data-grid';
import DxSelectBox from 'devextreme-vue/select-box';
import DxCheckBox from 'devextreme-vue/check-box';
import { generateData } from './data.js';

import BCardCode from '@core/components/b-card-code/BCardCode.vue';
import store from '@/store/index';
// import { codeBasic } from './code';

export default {
components: {
  DxDataGrid,
  DxScrolling,
  DxPager,
  DxPaging,
  DxCheckBox,
  DxSelectBox,
  BCardCode,
  BFormGroup,
  BFormCheckbox,
},
data() {
  return {
    dataSource: generateData(1000),
    displayModes: [
      { text: "Display Mode 'full'", value: 'full' },
      { text: "Display Mode 'compact'", value: 'compact' },
    ],
    displayMode: 'full',
    pageSizes: [5, 10, 20, 'all'],
    showPageSizeSelector: true,
    showInfo: true,
    showNavButtons: true,
    small: false,
    outlined: true,
    striped: true,
    bordered: true,
    borderless: true,
    hover: true,
    dark: false,
    resize: true,
    reOrder: true,
    headVariant: null,
  };
},
computed: {
  isCompactMode() {
    return this.displayMode === 'compact';
  },
},
methods: {
  customizeColumns(columns) {
    columns[0].width = 70;
  },
},
};
</script>
`;
